import { Base } from "../base";

export interface VolumeSetPerformanceClassInfoGroup {
  name: string;
  minCapacity: number;
  maxCapacity: number;
  readableName: string;
}

export const PerformanceClasses: VolumeSetPerformanceClassInfoGroup[] = [
  {
    name: "general-purpose-ssd",
    minCapacity: 10,
    maxCapacity: 65536,
    readableName: "General Purpose SSD",
  },
  {
    name: "high-throughput-ssd",
    minCapacity: 1000,
    maxCapacity: 65536,
    readableName: "High Throughput SSD",
  },
];

export interface VolumeSnapshot {
  name: string;
  id?: string;
  created: Date;
  expires?: Date;
  size?: number;
  tags?: {
    [x: string]: string;
  }[];
}
export interface PersistentVolumeStatus {
  lifecycle?: "creating" | "unused" | "unbound" | "bound" | "deleted" | "repairing";
  storageDeviceId?: string;
  index: number;
  currentSize: number;
  currentBytesUsed?: number;
  iops?: number;
  throughput?: number;
  driver: string;
  volumeSnapshots?: VolumeSnapshot[];
  attributes?: {
    [x: string]: string;
  };
}
export interface VolumeSetStatusLocation {
  name: string;
  volumes?: PersistentVolumeStatus[];
  desiredVolumeCount?: number;
  clusterId?: string;
}
export interface VolumeSetStatus {
  parentId?: string;
  usedByWorkload?: string;
  workloadLinks?: string[];
  bindingId?: string;
  locations?: VolumeSetStatusLocation[];
}
export interface SnapshotSpec {
  // createFinalSnapshot?: boolean; // deprecated
  retentionDuration?: string;
  schedule?: string;
}

export interface PredictiveScalingSpec {
  enabled?: boolean;
  lookbackHours?: number;
  projectionHours?: number;
  minDataPoints?: number;
  minGrowthRateGBPerHour?: number;
  scalingFactor?: number;
}

export interface ScalingSpec {
  maxCapacity?: number;
  minFreePercentage?: number;
  scalingFactor?: number;
  predictive?: PredictiveScalingSpec;
}

export interface MountOptionsResources {
  minMemory?: string;
  minCpu?: string;
  maxMemory?: string;
  maxCpu?: string;
}

export interface MountOptions {
  resources?: MountOptionsResources;
}

export type VolumeSetPerformanceClass = "general-purpose-ssd" | "high-throughput-ssd" | string;
export type VolumeSetFileSystemType = "xfs" | "ext4" | "shared";

export interface VolumeSetSpec {
  initialCapacity: number;
  performanceClass?: VolumeSetPerformanceClass;
  storageClassSuffix?: string;
  fileSystemType: VolumeSetFileSystemType;
  snapshots?: SnapshotSpec;
  autoscaling?: ScalingSpec;
  mountOptions?: MountOptions;
  customEncryption?: {
    regions?: Record<string, { keyId: string }>;
  };
}
export interface VolumeSet extends Base {
  spec: VolumeSetSpec;
  status?: VolumeSetStatus;
}
